import base from "../assets/images/base.png";
const stagingChainList = [
  {
    chianId: 1,
    chainIcon:
      "https://brevis-frontend.s3.us-west-1.amazonaws.com/provenet/imgs/eth.svg",
    chainName: "Ethereum",
    gasTokenSymbol: "ETH",
    blockExplorerUrl: "https://etherscan.io",
    rpcUrl: "https://eth.drpc.org",
  },
  {
    chianId: 8453,
    chainIcon: base,
    chainName: "Base",
    gasTokenSymbol: "ETH",
    blockExplorerUrl: "https://basescan.org",
    rpcUrl: "https://base-mainnet.public.blastapi.io",
  },
  {
    chianId: 421614,
    chainIcon:
      "https://brevis-frontend.s3.us-west-1.amazonaws.com/provenet/imgs/arbitrum.png",
    chainName: "Arbitrum Sepolia",
    gasTokenSymbol: "ETH",
    blockExplorerUrl: "https://sepolia.arbiscan.io",
    rpcUrl: "https://arbitrum-sepolia.gateway.tenderly.co",
  },
];
const mainnetChainList = [
  {
    chianId: 1,
    chainIcon:
      "https://brevis-frontend.s3.us-west-1.amazonaws.com/provenet/imgs/eth.svg",
    chainName: "Ethereum",
    gasTokenSymbol: "ETH",
    blockExplorerUrl: "https://etherscan.io",
    rpcUrl: "https://eth.drpc.org",
  },
  {
    chianId: 8453,
    chainIcon: base,
    chainName: "Base",
    gasTokenSymbol: "ETH",
    blockExplorerUrl: "https://basescan.org",
    rpcUrl: "https://base-mainnet.public.blastapi.io",
  },
  {
    chianId: 421614,
    chainIcon:
      "https://brevis-frontend.s3.us-west-1.amazonaws.com/provenet/imgs/arbitrum.png",
    chainName: "Arbitrum Sepolia",
    gasTokenSymbol: "ETH",
    blockExplorerUrl: "https://sepolia.arbiscan.io",
    rpcUrl: "https://arbitrum-sepolia.gateway.tenderly.co",
  },
];
export const deployChainList =
  process.env.REACT_APP_PUBLIC_APP_ENV === "production" ||
  process.env.REACT_APP_PUBLIC_APP_ENV === "staging"
    ? mainnetChainList
    : stagingChainList;

export const getChainInfoById = (id: number | undefined) => {
  const chainInfo = deployChainList.find((item) => item.chianId === Number(id));
  return chainInfo || deployChainList[0];
};

export const contract_address = {
  staking_viewer: "0x659F4172BEd39DeDF6D3f02a0A8AD5719Eafe41F",
  brevis_market: "0xcCec2a9FE35b6B5F23bBF303A4e14e5895DeA127",
  staking_controller: "0x9c0D8C5F10f0d3A02D04556a4499964a75DBf4A3",
  market_viewer: "0x0ED8C6e128D1Be1e521B6AcDC25b348829a4Ffd2",
};

// export const contract_address = {
//   staking_viewer: "0x9cC4a49667928Cba39BBb9d271BAC6736B122516",
//   brevis_market: "0x183cbf3aD6A647A10f591d9697410d6667268c04",
//   staking_controller: "0xa7CC9DfDbe44069677c5EcFFF732930B17b1364E",
//   market_viewer: "0x2f29A07841C60B98556582796bf4E856D0516B42",
// };

// old
// export const contract_address = {
//   staking_viewer: "0x4c38a1DfE3Cd52c0d264Eabe6e18a88D42F7D0ed",
//   brevis_market: "0x9c19d2De433217FB4b41a5D8d35aB8eE4A7b0DFa",
//   staking_controller: "0x4eE8ec243dceC0a6A5676470d4dBfA71CE96F069",
//   market_viewer: "0x00d24460e8803065BcbBb872dBb53aa6C12E6B94",
// };
export enum CacheAddress {
  cacheAddress = "cacheAddress",
}
